<template>
	<div>
		<title-bar :title-stack="titleStack"/>

		<section class="section is-main-section">
			<card-component title="" icon="">
				<b-field label="コイン名"
					horizontal
					custom-class="require"
					:type="{ 'is-danger': $utils.hasError(errors, 'name') }"
					:message="errors.name">
					<b-input type="text" v-model="name" />
				</b-field>

				<b-field label="要約"
					horizontal>
					<b-input type="textarea" v-model="wrapup" />
				</b-field>

				<b-field label="説明"
					horizontal>
					<b-input type="textarea" v-model="detail" />
				</b-field>

				<b-field label="カラー" horizontal>
					<chrome v-model="color"></chrome>
				</b-field>

				<b-field label="親コイン" horizontal>
					<b-select v-model="parentCoinId">
						<option value="">未選択</option>
						<option v-for="(row, index) in parentCoins" :key="index" :value="row.id">
							{{ row.name }}
						</option>
					</b-select>
				</b-field>

				<b-field label="コイン画像" horizontal>
					<div>
						<img class="preview" :src="imageBase" v-show="!image" :style="{ 'max-width': previewW + 'px' }">
						<image-picker class="mb-10" :previewUrl="image" :isLoading="isImageLoading" :previewW="previewW" @file-change="onImageChange" @delete="onImageDelete"></image-picker>
					</div>
				</b-field>

				<b-field label="単位"
					horizontal
					:type="{ 'is-danger': $utils.hasError(errors, 'unit') }"
					:message="errors.unit">
					<b-input type="text" v-model="unit" />
				</b-field>

				<!--
				<b-field label="獲得レート"
					horizontal
					custom-class="require"
					:type="{ 'is-danger': $utils.hasError(errors, 'recieveRate') }"
					:message="errors.recieveRate">
					<b-input type="text" v-model="recieveRate" />
				</b-field>

				<b-field label="贈呈レート"
					horizontal
					custom-class="require"
					:type="{ 'is-danger': $utils.hasError(errors, 'presentRate') }"
					:message="errors.presentRate">
					<b-input type="text" v-model="presentRate" />
				</b-field>
				-->

				<b-field label="" horizontal>
					<b-checkbox v-model="isActive">有効</b-checkbox>
				</b-field>

				<b-field class="mt-40" horizontal>
					<div>
						<b-button @click="$router.go(-1)">戻る</b-button>
						<b-button type="is-primary" class="ml-50" :loading="isLoading" @click="onSubmitClick">{{ !id ? '登録' : '更新' }}</b-button>
					</div>
				</b-field>
			</card-component>
		</section>
	</div>
</template>

<style lang="scss" scoped>
.preview {
	height: auto;
}
</style>

<script>
import TitleBar from '@/components/TitleBar'
import CardComponent from '@/components/CardComponent'
import mapValues from 'lodash/mapValues'
import CheckboxPicker from '@/components/CheckboxPicker'
import RadioPicker from '@/components/RadioPicker'
import ImagePicker from '@/components/ImagePicker'
import DatePicker from '@/components/DatePicker'
import { Chrome } from 'vue-color'

export default {
	name: 'Forms',
	components: {
		ImagePicker,
		RadioPicker,
		CheckboxPicker,
		CardComponent,
		TitleBar,
		DatePicker,
		Chrome,
	},
	data () {
		return {
			id: '',
			name: '',
			color: '',
			parentCoinId: '',
			image: '',
			imageBase: '',
			wrapup: '',
			detail: '',
			unit: '',
			recieveRate: 0,
			presentRate: 0,
			isActive: true,
			parentCoins: [],
			errors: {
				name: '',
				unit: '',
				recieveRate: '',
				presentRate: '',
			},
			isLoading: false,
			isImageLoading: false,
			previewW: 100,
		}
	},
	computed: {
		titleStack () {
			return [
				'コイン登録',
			]
		}
	},
	mounted() {
		this.init();
	},
	methods: {
		onImageDelete: function() {
			this.image = '';
		},
		onImageChange: function(file) {
			this.uploadImage(file);
		},
		uploadImage: async function(file, key) {
			this.isImageLoading = true;

			let data = {
				"image": file,
			};
			let ep = 'coins/image';

			try {
				let res = await this.$api.post(ep, data, true);
				this.$utils.log(res);
				this.image = res.data.url;
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				this.isImageLoading = false;
			}
		},
		onSubmitClick: async function() {
			for (let key in this.errors) {
				this.errors[key] = '';
			}

			this.isLoading = true;
			let data = {
				"id": this.id,
				"name": this.name,
				"color": this.$utils.isObject(this.color) ? this.color.hex : this.color,
				"parent_coin_id": this.parentCoinId,
				"image": this.image,
				"wrapup": this.wrapup,
				"detail": this.detail,
				"unit": this.unit,
				"recieve_rate": this.recieveRate,
				"present_rate": this.presentRate,
				"is_active": this.isActive,
			};

			this.$utils.log(data);

			try {
				let ep = 'coins';
				let res = await this.$api.post(ep, data, true);
				this.$utils.log(res);
				this.$utils.toastSuccess('データを更新しました');
				this.$router.push({ name: 'coin' });
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
				if (error.response.status === 400) {
					let details = error.response.data.details;
					for (let key in details) {
						this.errors[this.$utils.toCamelCase(key)] = details[key];
					}
				}
			} finally {
				this.isLoading = false;
			}
		},
		init: function() {
			this.getData();
		},
		getData: async function() {
			let loader = this.$buefy.loading.open();
			let params = this.$route.params.coinId ? '/' + this.$route.params.coinId: '';
			let ep = 'coins/screen' + params;
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				this.id = res.data.id;
				this.name = res.data.name;
				this.color = res.data.color;
				this.parentCoinId = res.data.parent_coin_id;
				this.image = res.data.image;
				this.imageBase = res.data.image_base;
				this.wrapup = res.data.wrapup;
				this.detail = res.data.detail;
				this.unit = res.data.unit;
				this.recieveRate = res.data.recieve_rate;
				this.presentRate = res.data.present_rate;
				this.isActive = res.data.is_active;
				this.parentCoins = res.data.parent_coins;
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				loader.close();
			}
		},
	}
}
</script>
